  <ion-content>
    <ag-charts-angular style="height: 100%; width: 100%;" [options]="chartOptions"></ag-charts-angular>

  </ion-content>
